import { withStyles } from "@material-ui/core";
import { BlocTextes } from "bc-front-sagacomponents";
import { formatDateCourt } from "../../../../helpers/formatters";
import { useGetAdherent } from "../../../../hooks/useGetAdherent";
import styles from "../../style";

interface Props {
  classes?: any;
  selectedAdhesionId?: string;
}
const AdherentContent = (props: Props) => {
  const { selectedAdhesionId } = props;

  const { listeAdherents } = useGetAdherent();

  const selectedAdherent = listeAdherents?.find((adh) =>
    adh.listAdhesion?.find((a) => a.numeroAdhesion === selectedAdhesionId)
  );
  return (
    <>
      {selectedAdherent && (
        <>
          {" "}
          {selectedAdherent.titre === "Sté" ? (
            <>
              <BlocTextes
                title=" "
                content={[
                  {
                    title: "Nom",
                    value: selectedAdherent.nom + " " + selectedAdherent.prenom,
                  },
                  {
                    title: "Date de naissance",
                    value:
                      selectedAdherent.dateNaissance &&
                      formatDateCourt(selectedAdherent.dateNaissance),
                  },
                ]}
              />
            </>
          ) : (
            <BlocTextes
              red
              title=" "
              content={[
                {
                  title: "Nom Prénom",
                  value: (
                    (selectedAdherent.titre !== null
                      ? selectedAdherent.titre
                      : "") +
                    " " +
                    selectedAdherent.nom +
                    " " +
                    selectedAdherent.prenom
                  ).toString(),
                },
                {
                  title: "Nom de naissance",
                  value: selectedAdherent.nomNaissance,
                },
                {
                  title: "Date de naissance",
                  value:
                    selectedAdherent.dateNaissance &&
                    formatDateCourt(selectedAdherent.dateNaissance),
                },
                {
                  title: "Lieu de naissance",
                  value: selectedAdherent.lieuNaissance,
                },
              ]}
            />
          )}
          <BlocTextes
            red
            title=" "
            content={[
              { title: "Adresse", value: selectedAdherent.adresse?.adresse1 },
              {
                title: "Complément d'adresse",
                value: selectedAdherent.adresse?.adresse2,
              },
              {
                title: "Code Postal / Ville",
                value:
                  selectedAdherent.adresse?.codePostal +
                  " / " +
                  selectedAdherent.adresse?.ville,
              },
              { title: "Pays", value: "France" },
              { title: "E-mail", value: selectedAdherent.email },
              { title: "Téléphone", value: selectedAdherent.telephone },
              { title: "Autre téléphone", value: selectedAdherent.telephone2 },
            ]}
          />
        </>)}
    </>
  );
};
export default withStyles(styles)(AdherentContent);
